<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="1201126775"
        label="日期"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row }}
        </template>
      </el-table-column>
      <el-table-column
        prop="1201126775"
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { sprmessageInfo } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      account_id: '',
      type: '',
      tableData: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    open(account_id, type) {
      this.account_id = account_id
      this.type = type
      this.list()
      console.log(account_id, type)
    },
    async list() {
      const data = await sprmessageInfo({
        account_id: this.account_id,
        type: this.type
      })
      this.tableData = data.data
      console.log('data', data)
    },
    choose(item) {
      console.log(item)
      this.$emit('updata', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
